module.exports = __webpack_public_path__ + "img/图片3.8f484990.png";